package com.appcreator.blueprint.firebase.functions

import com.appcreator.blueprint.core.DataShape
import com.appcreator.blueprint.core.LoaderSpec
import com.appcreator.blueprint.core.findParameters
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
@SerialName("FirebaseFunctionsLoaderSpec")
data class FirebaseFunctionsLoaderSpec(
    override val id: String,
    override val parameterSettings: Map<String, LoaderSpec.ParameterSetting>?,
    override val dataShape: DataShape?,
    val name: String?,
    val queryParameters: Map<String, String>?,
    val dataShapeLoadUrl: String?
): LoaderSpec {

    override val supportsPaging: Boolean get() = false

    override val parameters: Set<String>
        get() {
            return queryParameters?.values?.map { it.findParameters() }?.flatten()?.toSet()?: emptySet()
        }

}
